export const notionColors = ['gray', 'brown', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'red', 'default'];

export const getNotionBackgroundColor = (color) => {
  switch (color) {
    case 'gray':
      return 'rgb(227, 226, 224)';
    case 'brown':
      return 'rgb(238, 224, 218)';
    case 'orange':
      return 'rgb(250, 222, 201)';
    case 'yellow':
      return 'rgb(253, 236, 200)';
    case 'green':
      return 'rgb(219, 237, 219)';
    case 'blue':
      return 'rgb(211, 229, 239)';
    case 'purple':
      return 'rgb(232, 222, 238)';
    case 'pink':
      return 'rgb(245, 224, 233)';
    case 'red':
      return 'rgb(255, 226, 221)';
    default:
      return 'rgba(227, 226, 224, 0.5)';
  }
};

export const getNotionFontColor = (color) => {
  switch (color) {
    case 'gray':
      return 'rgb(50, 48, 44)';
    case 'brown':
      return 'rgb(68, 42, 30)';
    case 'orange':
      return 'rgb(73, 41, 14)';
    case 'yellow':
      return 'rgb(64, 44, 27)';
    case 'green':
      return 'rgb(28, 56, 41)';
    case 'blue':
      return 'rgb(24, 51, 71)';
    case 'purple':
      return 'rgb(65, 36, 84)';
    case 'pink':
      return 'rgb(76, 35, 55)';
    case 'red':
      return 'rgb(93, 23, 21)';
    default:
      return 'rgb(50, 48, 44)';
  }
};
